import { PaginationOptions } from "hooks/api/useApiGetWithPagination";
import useApiPostWithPagination from "hooks/api/useApiPostWithPagination";
import { Filter } from "features/Rsql/types/RsqlFilters";
import getRsqlQueryString from "features/Rsql/utils/getRsqlQueryString";
import endpoints from "hooks/api/endpoints";
import useProject from "hooks/useProject";
import { VideoClass } from "types/VideoDto";
import Sorting from "../types/Sorting";
import MiscFilters from "./types/MiscFilters";
import VideoFields from "./types/VideoFields";

export interface GetVideosParams {
  miscFilters?: MiscFilters;
  filters?: Filter<VideoFields>[] | undefined;
  sorting?: Sorting<VideoFields>;
  options?: PaginationOptions;
  suspendQuery?: boolean;
}

export default function useGetVideos(params?: GetVideosParams) {
  const { projectId } = useProject();

  const { miscFilters, filters, suspendQuery, options, sorting } = params || {};
  const { tagIds } = miscFilters || {};
  const queryParams: string[] = [];
  if (sorting && sorting.length > 0) {
    queryParams.push(
      `sorting=${sorting.map(({ sortBy, direction }) => `${sortBy}:${direction || "desc"}`).join(",")}`,
    );
  }
  if (tagIds && tagIds.length > 0)
    queryParams.push(`tagIds=${tagIds.join(",")}`);

  const result = useApiPostWithPagination<VideoClass>(
    suspendQuery ? "" : endpoints.getVideos(projectId, queryParams.join("&")),
    {
      query: getRsqlQueryString<VideoFields>({
        rsqlFilters: { and: filters || [] },
      }),
    },
    { options },
  );

  return {
    ...result,
    combinedPageResults: (result.dataList || []).map((v) => new VideoClass(v)),
  };
}
